import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AttachmentService } from '../../core/services/attachment';
import * as sofActions from '../actions/sof.action';

@Injectable()
export class SOFEffects {
  private actions$ = inject(Actions);

  private attachmentService = inject(AttachmentService);

  loadSOF$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sofActions.LOAD_SERVICE_ORDER_FORMS),
      switchMap(() =>
        this.attachmentService.getServiceOrderFormFiles().pipe(
          map((forms) => new sofActions.LoadServiceOrderFormsSuccess(forms)),
          catchError((error) =>
            of(new sofActions.LoadServiceOrderFormsFail(error)),
          ),
        ),
      ),
    ),
  );
}
